import { Component } from '@angular/core';

@Component({
  selector: 'app-claim-submission-banca',
  templateUrl: './claim-submission-banca.component.html',
  styleUrls: ['./claim-submission-banca.component.scss']
})
export class ClaimSubmissionBancaComponent {

  resetOnlineSubmissionTab: Boolean = false;
  resetAdditionalDocSubmissionTab: Boolean = false;
  protected selectedTab: number = 0;

  resetOnlineClaimSubmissionTab(data) {
    this.selectedTab = data;
    sessionStorage.removeItem('requestToken');
    if (data == 1) {
      this.resetOnlineSubmissionTab = true;
    } else {
      this.resetAdditionalDocSubmissionTab = true;
    }
  }

  resetOnlineSubmissionTabValue() {
    this.resetOnlineSubmissionTab = false;
  }

  resetAdditionalDocSubmissionTabValue() {
    this.resetAdditionalDocSubmissionTab = false;
  }
}
